const config = {
    "localhost": {
        "hubUrl": "http://hub.kontron/",
        "hubApiUrl": "http://hub.kontron/v1/",
        "developmentMode": true,
    },

    "192.168.0.150": {
        "hubUrl": "http://192.168.0.150:8080/",
        "hubApiUrl": "http://192.168.0.150:8080/v1/",
        "developmentMode": true,
    },

    "navigate.holiday": {
        "hubUrl": "https://hub.navigate.holiday/",
        "hubApiUrl": "https://hub.navigate.holiday/v1/",
        "developmentMode": false,
        "defaultLanguage": "de",
        "fallbackLanguage": "en",
    },

    "resort.navigate.holiday": {
        "hubUrl": "https://resort-hub.navigate.holiday/",
        "hubApiUrl": "https://resort-hub.navigate.holiday/v1/",
        "developmentMode": false,
    },

    "airline.navigate.holiday": {
        "hubUrl": "https://airline-hub.navigate.holiday/",
        "hubApiUrl": "https://airline-hub.navigate.holiday/v1/",
        "developmentMode": false,
    },

    "airport.navigate.holiday": {
        "hubUrl": "https://airport-hub.navigate.holiday/",
        "hubApiUrl": "https://airport-hub.navigate.holiday/v1/",
        "developmentMode": false,
        "gaCode": "UA-152934923-2",
    },

    "bus.navigate.holiday": {
        "hubUrl": "https://bus-hub.navigate.holiday/",
        "hubApiUrl": "https://bus-hub.navigate.holiday/v1/",
        "developmentMode": false,
    },

    "allaboard.app.ambassadorcruiseline.com": {
        "hubUrl": "https://pt.ambassadorcruiseline.com/",
        "hubApiUrl": "https://pt.ambassadorcruiseline.com/v1/",
    }
}
export default config;